
<template>

  <img class="block w-full max-w-[260px] mx-auto" src="../images/activity-2-part-1-coffee.png" alt="A white, ceramic coffee container" />

  <p class="mt-6 text-neutral-700">
    
    When nature calls, you might not be near a restroom—or at least one that will allow African Americans to use it.
  
  </p>

</template>
